module.exports = __webpack_public_path__ + "static/media/app-store-logo.a01b22c0.png";